// Signifies that we should come back and type this after the relevant types are added to action features, etc

export function cleanZombieBranchConnector({
  branch,
  flow
}) {
  let updatedBranch = branch;
  const connector = updatedBranch.getConnector();
  if (connector && !flow.getActionById(connector.getNextActionId())) {
    updatedBranch = updatedBranch.setConnector(null);
  }
  return updatedBranch;
}
export function cleanZombieConnections({
  connection,
  flow
}) {
  const branches = connection.getBranches();
  let updatedConnection = connection;
  if (branches && !branches.isEmpty()) {
    const cleanedBranches = branches.map(branch => cleanZombieBranchConnector({
      branch,
      flow
    }));
    updatedConnection = updatedConnection.setBranches(cleanedBranches);
  }
  return updatedConnection;
}
export function cleanZombieDefaultConnection({
  connection,
  flow
}) {
  let updatedConnection = connection;
  const updatedDefaultConnector = connection.getDefaultConnector();
  if (updatedDefaultConnector && !flow.getActionById(updatedDefaultConnector.getNextActionId())) {
    updatedConnection = updatedConnection.setDefaultConnector(null);
  }
  return updatedConnection;
}
export function cleanActionGoToBranches({
  flow,
  action
}) {
  let cleanedAction = action;
  let updatedConnection = cleanZombieConnections({
    connection: action.getConnection(),
    flow
  });
  updatedConnection = cleanZombieDefaultConnection({
    connection: updatedConnection,
    flow
  });
  cleanedAction = cleanedAction.setConnection(updatedConnection);
  return cleanedAction;
}